$('.testimonial-slider__carousel').slick({
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 3,
    adaptiveHeight: false,
    arrows: false,
    draggable: true,
    autoplay: true,
    autoplaySpeed: 4000,
    fade: false,
    responsive: [
        {
            breakpoint: 1250,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
            }
        },
        {
            breakpoint: 650,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        }

    ]
});
